S.buttonLoadMore =
    {
        config: {
        },

        elements: {
        },

        init()
        {

            this.$module.click(function () {
                if($(this).hasClass('opened')){
                    $(this).parent().find('.m-text-croped').show(200);
                }else{
                    $(this).parent().find('.m-text-croped').hide(200);
                }
                $(this).parent().find('.m-text-more').slideToggle();
                $(this).toggleClass('opened');
            })
        },
    };